import type { Namespace } from './types';
export const zh: Namespace = {
  bind: {
    title: '绑定 CDKey',
    cdkeyCode: 'CDKey',
    username: 'Steam 账号',
    password: '密码',
    required: '请输入这一项',
    submit: '绑定并开登',
    binding: '绑定中…',
    statusTitle: '绑定进度',
    stepBind: '绑定',
    stepVerify: '验证',
    stepResult: '结果',
    code: '验证码',
    codePlaceholder: '请输入 Steam 验证码',
    submitCode: '提交验证码',
    // 写操作回执（2026-10-23 补：三态各给一句，别让「没反应」=「失败了」）。
    success: '绑定成功',
    awaiting: '已受理，请填写 Steam 验证码',
    codeSubmitted: '验证码已提交，正在等待结果',
    orderNo: '订单号',
    amountLabel: '面额',
    updatedAt: '最后更新',
    restart: '重新绑定',
    states: {
      waiting_code: '等验证码',
      logging_in: '登录中',
      success: '成功',
      failed: '失败',
    },
    hints: {
      waiting_code: '请填写 Steam 验证码并提交。',
      logging_in: '正在登录 Steam，稍候。',
      success: '已登录成功。',
      failed: '登录失败。',
    },
    loginFailedTitle: '登录失败',
    loginFailedHint: '卡已绑定成功，但 Steam 登录未完成。重新提交将重试登录。',
    retryLogin: '重试登录',
    unknownState: '未知状态',
    errors: {
      failed: '兑换未成功，请稍后重试',
    },
  },
};

export const en: Namespace = {
  bind: {
    title: 'Bind a CDKey',
    cdkeyCode: 'CDKey',
    username: 'Steam account',
    password: 'Password',
    required: 'This field is required',
    submit: 'Bind and sign in',
    binding: 'Binding…',
    statusTitle: 'Binding progress',
    stepBind: 'Bind',
    stepVerify: 'Verify',
    stepResult: 'Result',
    code: 'Verification code',
    codePlaceholder: 'Enter the Steam verification code',
    submitCode: 'Submit code',
    // Write-operation receipts (2026-10-23): one line per outcome.
    success: 'Bound',
    awaiting: 'Accepted — fill in the Steam verification code',
    codeSubmitted: 'Code submitted — waiting for the result',
    orderNo: 'Order',
    amountLabel: 'Amount',
    updatedAt: 'Last updated',
    restart: 'Bind again',
    states: {
      waiting_code: 'Awaiting code',
      logging_in: 'Signing in',
      success: 'Succeeded',
      failed: 'Failed',
    },
    hints: {
      waiting_code: 'Fill in the Steam code and submit.',
      logging_in: 'Signing in to Steam — please wait.',
      success: 'Signed in successfully.',
      failed: 'Sign-in failed.',
    },
    loginFailedTitle: 'Sign-in failed',
    loginFailedHint:
      'Your card is bound, but the Steam sign-in did not complete. Submitting again retries the sign-in.',
    retryLogin: 'Retry sign-in',
    unknownState: 'Unknown state',
    errors: {
      failed: 'The redemption did not succeed — please try again later',
    },
  },
};
